import { variablesGlobales } from "../../configs/variables";
import getInstanceAxios from "../axiosInstance";

export class CreditsService {
  static async updateCreditFromOfferPage(data = {}) {
    try {
      let axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/credits/updateFromOfferPage`,
        data,
      );
      const jsonData = await responseServer.data;
      return {
        error: false,
        message: jsonData,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data ?? error.message,
        date: new Date(),
        code: error.code,
        status: 500,
      };
    }
  }

  static async updateBankCredit(data = {}, documento) {
    try {
      let axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.put(
        `${variablesGlobales.urlServiceBackend}/api/v1/info/updateAccountByNewFlow/${documento}`,
        data,
      );
      const jsonData = await responseServer.data;
      return {
        error: false,
        message: jsonData,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data ?? error.message,
        date: new Date(),
        code: error.code,
        status: 500,
      };
    }
  }

  static async getBanckPrincipal(documento) {
    try {
      let axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.get(
        `${variablesGlobales.urlServiceBackend}/api/v1/info/getBankAccounts/${documento}`,
      );
      const jsonData = await responseServer.data;
      return {
        error: false,
        message: jsonData,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data ?? error.message,
        date: new Date(),
        code: error.code,
        status: 500,
      };
    }
  }

  static async getCreditsPaginate(data = {}) {
    try {
      let axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/credits/getCreditsPaginate`,
        data,
      );
      const jsonData = await responseServer.data;
      return {
        error: false,
        message: jsonData,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data ?? error.message,
        date: new Date(),
        code: error.code,
        status: 500,
      };
    }
  }

  static async getScoreFromPolicy(credit_id) {
    try {
      let axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.get(
        `${variablesGlobales.urlServiceBackend}/api/v1/credits/getCurrentScoreFromPolicies/${credit_id}`,
      );
      const jsonData = await responseServer.data;
      return {
        error: false,
        message: jsonData,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data ?? error.message,
        date: new Date(),
        code: error.code,
        status: 500,
      };
    }
  }
}
